import { nanoid } from 'nanoid';

import { toggleBlock } from '../../3rd-party/rich-text';
import elementTypes from '../../elements/types';
import HelptapEditor from '../';
import * as baseNodeUtilities from './base-node';

export function getDefaultOptions(properties = {}) {

  const options = {
    ...baseNodeUtilities.getDefaultOptions(),
    children: [{
      text: ''
    }],
    properties: {
      id: nanoid(),
      template: null,
      parentEntityId: null,
      parentEntityType: null,
      clonerId: null,
      customization: {
        description: ''
      },
      ...properties
    },
    type: elementTypes.TEMPLATE_CLONER
  };

  return options;

}

export function insert(editor, properties) {

  const node = {
    ...getDefaultOptions(properties)
  };

  HelptapEditor.insertNode(editor, node);

}

export function toggle(editor, properties) {

  toggleBlock(editor, elementTypes.TEMPLATE_CLONER, getDefaultOptions(properties));

}

export function cloneNode(node) {

  const clonedNode = HelptapEditor.cloneNode(node);

  clonedNode.properties.id = nanoid();

  return clonedNode;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}